import { AutocompleteRenderInputParams } from '@mui/material'
import { STextField } from './AutocompleteInput.styles'

interface AutocompleteInputProps extends AutocompleteRenderInputParams {
  placeholder?: string
}

const AutocompleteInput = (props: AutocompleteInputProps): JSX.Element => (
  <STextField {...props} variant="standard" />
)

export default AutocompleteInput
